function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useSelector } from 'react-redux';
import featureEnabled from 'shared/helper/feature';
import { convertedPrice } from 'researcher/helpers/price';
import { getChinaAvailableNewPlans } from '../../../reducer';
import { PADDLE_PLAN_TYPES } from '../../../constants';
import formatMoney from '../formatMoney';
var hasValidDiscount = function hasValidDiscount(plan) {
  return plan.discountPercent > 0 && plan.discountPercent < 100;
};
var useChinaPlanPricing = function useChinaPlanPricing() {
  var currency = useSelector(function (_ref) {
    var user = _ref.user;
    return user.currency;
  });
  var chinaPlans = useSelector(getChinaAvailableNewPlans);
  var discountsEnabled = featureEnabled('china_plans_discount_offers');
  var toMoney = function toMoney(amount) {
    return formatMoney({
      amount: convertedPrice(currency, amount, true),
      symbol: currency.sign
    });
  };
  var getAnnualPricing = function getAnnualPricing(planGroup) {
    var plan = (chinaPlans[planGroup] || []).find(function (candidate) {
      return candidate.billingInterval === PADDLE_PLAN_TYPES.YEARLY;
    });
    if (!plan) {
      return {
        plan: null,
        price: null,
        yearlySavings: null
      };
    }
    if (!discountsEnabled || !hasValidDiscount(plan)) {
      return {
        plan: plan,
        price: toMoney(plan.price),
        yearlySavings: null
      };
    }
    var discountedPrice = plan.price * (1 - plan.discountPercent / 100);
    return {
      plan: plan,
      price: toMoney(discountedPrice),
      yearlySavings: toMoney(plan.price - discountedPrice)
    };
  };
  var getOneTimePricing = function getOneTimePricing(planGroup) {
    var _ref2 = chinaPlans[planGroup] || [],
      _ref3 = _slicedToArray(_ref2, 1),
      plan = _ref3[0];
    return plan ? toMoney(plan.price) : null;
  };
  return {
    getAnnualPricing: getAnnualPricing,
    getOneTimePricing: getOneTimePricing
  };
};
export default useChinaPlanPricing;